import {
  DefaultTheme as NavLightTheme,
  ThemeProvider,
} from "@react-navigation/native";
import { AppProviders as BaseAppProvider } from "@gaddario98/react-core/providers";
import { PropsWithChildren } from "react";

export interface AppProvidersProps extends PropsWithChildren {
  theme?: {
    background?: string;
    primary?: string;
    text?: string;
    card?: string;
    border?: string;
    notification?: string;
  };
  dark?: boolean;
}

export const AppProviders: React.FC<AppProvidersProps> = ({
  children,
  theme,
  dark = true,
}) => {
  return (
    <BaseAppProvider>
      <ThemeProvider
        value={{
          fonts: NavLightTheme.fonts,
          colors: {
            background: theme?.background ?? "#121212",
            border: theme?.border ?? "#333333",
            primary: theme?.primary ?? "#6200ee",
            text: theme?.text ?? "#ffffff",
            card: theme?.card ?? "#121212",
            notification: theme?.notification ?? "#6200ee",
          },
          dark,
        }}
      >
        {children}
      </ThemeProvider>
    </BaseAppProvider>
  );
};
